module.exports = __webpack_public_path__ + "media/images/app/header/heart-3c1407a0ab4ad378b8d35c9e97911789.svg";